<template>
  <div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="user" class="mb-1"><b><u class="section-title"><i class="fas fa-users"></i>&nbsp;&nbsp;Usuarios&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></label>
        <input v-model="filter.user" type="text" class="form-control input_sm" name="user" placeholder="Nombre, Usuario, Correo ó Documento" @keyup.enter="getRecords(null)">
      </div>
      <div class="form-group col-md-4">
        <label for="role" class="mb-1"><b>Rol</b></label>
        <v-select v-model="filterRole" :options="roles" class="my-custom-select" placeholder="Todos"></v-select>
      </div>
      <div class="col-md-12">
        <button class="btn btn-sm btn-success btn-icon-split" title="Filtrar o buscar registro" @click="getRecords(null)"><i class="fas fa-filter"></i> Filtrar</button>
        <button class="btn btn-sm btn-danger btn-icon-split" title="Borrar filtro" @click="clearFilter()"><i class="fas fa-ban"></i></button>
      </div>
      <div class="col-12 text-right mt-1">
        <button @click="create" class="btn btn-sm btn-warning mt-1 mr-1" title="Agregar registro"><i class="fas fa-plus"></i> Nuevo</button>
        <hr>
      </div>
    </div>

    <b-overlay :show="loading" rounded="sm">
      <div class="table-responsive tableBg">
        <table class="table table-striped table-bordered zero-configuration">
          <thead>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Usuario</th>
              <th>Nombre</th>
              <th>Documento</th>
              <th>Correo Electrónico</th>
              <th>Rol</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <!-- Correo sin validar: la fila entera se pinta en rojo (ver .row-unverified
                 en style.css; 'text-danger' a secas NO vale, lo pisa el rayado). -->
            <tr v-for="(record, index) in records" :key="index"
                :class="{ 'row-unverified': !record.email_verified }"
                :title="record.email_verified ? '' : 'Correo sin validar: no puede iniciar sesión'">
              <td>{{ record.index }}</td>
              <td class="actions-cell">
                <button v-if="!record.is_self" class="btn btn-sm btn-danger btn-icon-split btn-xs" @click="destroy(record.id, record.user)" title="Eliminar">
                  <span class="icon text-white">
                    <i class="fas fa-trash icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-info btn-icon-split btn-xs" title="Editar" @click="showForm(record.id)">
                  <span class="icon text-white">
                    <i class="fas fa-edit icon_white"></i>
                  </span>
                </button>
                <button v-if="!record.is_self" class="btn btn-sm btn-warning btn-icon-split btn-xs" @click="changeStatus(record.id, record.user)" title="Cambiar Estado">
                  <span class="icon text-white">
                      <i class="fas fa-flag icon_white"></i>
                  </span>
                </button>
                <button class="btn btn-sm btn-success btn-icon-split btn-xs" @click="showRecord(record)" title="Ver">
                  <span class="icon text-white">
                    <i class="fas fa-eye icon_white"></i>
                  </span>
                </button>
                <!-- Acciones adicionales: van aquí para no seguir engordando la fila de botones.
                     Las dos vías de activación se ven por su nombre en el menú; cada una
                     abre el mismo modal en su modo. -->
                <b-dropdown size="sm" variant="light" no-caret toggle-class="btn-icon-split btn-xs"
                            class="actions-dropdown" title="Más acciones">
                  <template #button-content>
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                  </template>
                  <b-dropdown-item @click="changePassword(record.id, record.user)">
                    <i class="fas fa-key fa-fw"></i> Cambiar clave
                  </b-dropdown-item>
                  <b-dropdown-item v-if="!record.email_verified" @click="activate(record, 'verify')">
                    <i class="fas fa-user-check fa-fw"></i> Validar correo
                  </b-dropdown-item>
                  <b-dropdown-item v-if="!record.email_verified" @click="activate(record, 'resend')">
                    <i class="fas fa-envelope fa-fw"></i> Reenviar activación
                  </b-dropdown-item>
                </b-dropdown>
              </td>
              <td>{{ record.user }}</td>
              <td>{{ record.fullname }}</td>
              <td>{{ record.doctype }} {{ record.document_number }}</td>
              <td>{{ record.email }}</td>
              <td>{{ record.rolename }}</td>
              <td>
                <div class="badge" :class="statusClass(record.status)">
                    {{ statusLabel(record.status) }}
                </div>
              </td>
            </tr>
            <tr v-if="total == 0">
              <td colspan="8">No hay registros</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Usuario</th>
              <th>Nombre</th>
              <th>Documento</th>
              <th>Correo Electrónico</th>
              <th>Rol</th>
              <th>Estado</th>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- Contenedor de paginación -->
      <div class="pagination-container d-flex justify-content-end">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" v-for="link in links" :class="{'disabled': link.url == null, 'active': link.active}">
              <a class="page-link" @click="getRecords(link.url)" v-html="link.label"></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="text-right">
        <span><i style="font-size: 14px; color: #7A7A7A">Cantidad de registros: {{total}}</i></span>
        <hr>
        <br>
      </div>
    </b-overlay>
    <modal-form :id="recordId" :showModal.sync="showModalForm" @getRecords="getRecords"></modal-form>
    <modal-status :code="recordCode" :id="recordId" :showModal.sync="showModalStatus" @getRecords="getRecords"></modal-status>
    <modal-destroy :code="recordCode" :id="recordId" :showModal.sync="showModalDestroy" @getRecords="getRecords"></modal-destroy>
    <modal-record v-if="recordId" :record="dataRecord" :showModal.sync="showModalRecord" @getRecords="getRecords"></modal-record>
    <modal-password :code="recordCode" :id="recordId" :showModal.sync="showModalPassword" @getRecords="getRecords"></modal-password>
    <modal-activate :code="recordCode" :email="recordEmail" :mode="activateMode" :id="recordId" :showModal.sync="showModalActivate" @getRecords="getRecords"></modal-activate>
  </div>
</template>

<script>
import ModalForm from './partials/ModalForm.vue'
import ModalStatus from './partials/ModalStatus.vue'
import ModalDestroy from './partials/ModalDestroy.vue'
import ModalRecord from './partials/ModalRecord.vue'
import ModalPassword from './partials/ModalPassword.vue'
import ModalActivate from './partials/ModalActivate.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { BOverlay, BDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
  components: {ModalForm, BOverlay, ModalStatus, ModalDestroy, ModalRecord, ModalPassword, ModalActivate, BDropdown, BDropdownItem, vSelect},
  data() {
    return {
      records: [],
      loading: false,
      filter: {},
      filterRole: null,
      roles: [],
      links: {},
      total: 0,
      recordId: null,
      recordCode: null,
      // Declaradas aquí porque Vue 2 no hace reactivas las propiedades añadidas después.
      recordEmail: null,
      activateMode: 'verify',
      dataRecord: [],
      showModalForm: false,
      showModalStatus: false,
      showModalDestroy: false,
      showModalRecord: false,
      showModalPassword: false,
      showModalActivate: false
    }
  },
  created() {
    this.getRoles()
    this.getRecords(null)
  },
  methods:{
    statusLabel(status) {
      // El 2 ("pendiente de activar") ya no existe; se conserva por si queda algún
      // registro antiguo sin migrar.
      const labels = {1: 'Activo', 0: 'Bloqueado', 2: 'Pendiente', 3: 'Bloqueado permanente'}
      return labels[status] !== undefined ? labels[status] : 'Desconocido'
    },
    statusClass(status) {
      const classes = {1: 'badge-success', 0: 'badge-danger', 2: 'badge-warning', 3: 'badge-dark'}
      return classes[status] !== undefined ? classes[status] : 'badge-secondary'
    },
    getRoles() {
      axios.get('/configuration/users/getRoles')
        .then(response => {
          this.roles = response.data.data
        })
        .catch(error => {
          console.error(error)
        })
    },
    clearFilter(){
      this.filter = {};
      this.filterRole = null;
      this.getRecords(null)
    },
    getRecords(url = null) {
      this.loading = true
      let page = 1
      if(url) {
        let param = new URL(url);
        page = param.searchParams.get("page");
      }
      const params = Object.assign({}, this.filter, {
        role_id: this.filterRole ? this.filterRole.value : null
      })
      axios.get(`/configuration/users/records?page=${page}`, {params: params})
        .then(response => {
          this.records = response.data.data.data
          this.links = response.data.data.links
          this.total = response.data.data.total
        })
        .catch((error)=>{
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showForm(id) {
      this.recordId = id
      this.showModalForm = true
    },
    create() {
      this.recordId = null
      this.showModalForm = true
    },
    changeStatus(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalStatus = true
    },
    destroy(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalDestroy = true
    },
    showRecord(record) {
      this.recordId = record.id
      this.dataRecord = record
      this.showModalRecord = true
    },
    changePassword(id, code) {
      this.recordId = id
      this.recordCode = code
      this.showModalPassword = true
    },
    // mode: 'verify' valida el correo a mano; 'resend' restablece la clave al número de
    // documento y envía los datos de acceso con el enlace de activación.
    activate(record, mode) {
      this.recordId = record.id
      this.recordCode = record.user
      this.recordEmail = record.email
      this.activateMode = mode
      this.showModalActivate = true
    },
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 10px !important; /* Ajusta según sea necesario */
}
</style>
